let isMobileBreakpoint = window.innerWidth <= 800;

function spotlightPushDataLayer(payload) {
  if (!window.spotlightIsProduction) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

function spotlightCleanDataLayerText(element) {
  return element ? element.textContent.replace(/\s+/g, " ").trim() : "";
}

function spotlightAjax(request, options) {
  const jq = window.jQuery || window.$;

  if (!jq?.ajax) {
    return null;
  }

  return options ? jq.ajax(request, options) : jq.ajax(request);
}

function spotlightHasAjax() {
  const jq = window.jQuery || window.$;

  return !!jq?.ajax;
}

function spotlightTrackAccordionOpen(accordionType, accordionItem) {
  if (!accordionItem) {
    return;
  }

  spotlightPushDataLayer({
    event: "accordion_open",
    accordionType,
    accordionItem,
  });
}

function spotlightGetImageBlockName(cardElement, moduleSelector) {
  const moduleEl = cardElement.closest?.(moduleSelector);
  const heading = moduleEl?.querySelector("h2.wp-block-heading");

  return spotlightCleanDataLayerText(heading).toLowerCase();
}

function spotlightTrackImageBlockClick(blockName, linkText, linkURL) {
  if (!linkText || !linkURL) {
    return;
  }

  spotlightPushDataLayer({
    event: "click_image_block",
    blockName,
    linkText,
    linkURL,
  });
}

document.addEventListener("click", (event) => {
  // Category badge is a deliberately different destination (category archive,
  // not the article) and is excluded from card-click tracking.
  const link = event.target.closest(".news-card__image a, .news-card__title a");

  if (!link || event.defaultPrevented || event.button !== 0) {
    return;
  }

  const card = link.closest(".news-card");
  const titleLink = card?.querySelector(".news-card__title a");
  const linkText = spotlightCleanDataLayerText(titleLink).toLowerCase();
  const linkURL = titleLink?.href || link.href;

  if (!linkText || !linkURL) {
    return;
  }

  spotlightTrackImageBlockClick(
    spotlightGetImageBlockName(card, ".section-news-advice"),
    linkText,
    linkURL,
  );

  // New tab/window: current page never unloads, nothing else to do.
  if (link.target === "_blank" || event.metaKey || event.ctrlKey) {
    return;
  }

  // Same-tab navigation: delay just long enough for the push above to
  // reach GTM before the browser unloads the page.
  event.preventDefault();
  window.setTimeout(() => {
    window.location.href = linkURL;
  }, 250);
});

function spotlightShouldTrackHomeTestimonials() {
  return (
    window.location.pathname === "/" ||
    document.body.classList.contains("home") ||
    document.body.classList.contains("front-page")
  );
}

function spotlightTrackTestimonialCarouselNav(direction) {
  if (!spotlightShouldTrackHomeTestimonials()) {
    return;
  }

  spotlightPushDataLayer({
    event: "testimonial_carousel_nav",
    direction,
  });
}

function spotlightIsNewsAdvicePage() {
  const pathname = window.location.pathname.replace(/\/$/, "");

  return pathname === "/news-and-advice" || pathname.startsWith("/news-and-advice/");
}

//SCROLL TRIGGER ENTRANCE ANIMS
function scrollTriggerAnims() {
  const scrollTriggers = document.querySelectorAll(".s-trig");
  const scrollObserver = new IntersectionObserver(onScrollTrigger, {
    threshold: [0.1, 0.33],
  });
  let firstPass = true;
  function onScrollTrigger(entries) {
    entries.forEach((entry) => {
      if (firstPass && !entry.isIntersecting) {
        entry.target.classList.add("set-up");
      } else if (
        !firstPass &&
        entry.isIntersecting &&
        entry.intersectionRatio >= 0.33
      ) {
        entry.target.classList.remove("set-up");
      }
    });
    firstPass = false;
  }
  scrollTriggers.forEach((trig) => {
    scrollObserver.observe(trig);
  });
}

//VIDEO PLAYER OBSERVER
function startStopVideos() {
  const vids = document.querySelectorAll(".bgr-vid");
  const vidObserver = new IntersectionObserver(onVidIntersect, {
    threshold: [0.5],
  });

  function onVidIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (!entry.target.classList.contains("user-paused")) {
          entry.target.play();
        }
      } else {
        entry.target.pause();
      }
    });
  }
  vids.forEach((vid) => {
    vidObserver.observe(vid);

    const playButton = vid.nextElementSibling;
    if (!playButton) {
      return;
    }

    playButton.addEventListener("click", function () {
      if (vid.classList.contains("user-paused")) {
        vid.classList.remove("user-paused");
        vid.play();
      } else {
        vid.classList.add("user-paused");
        vid.pause();
      }
    });
  });
}

//STATS SCROLL ANIM
const statsRow = document.querySelector("#statistics .slides");
const statsContent = document.querySelector("#statistics .content");

//HOW MUCH SPACE AT TOP OF ANIM
const topPadding = 300;

//HOW MUCH SPACE AT BOTTOM OF ANIM
const bottomPadding = 64;

let easedTrans = 0;

function statsScrollAnim() {
  if (!isMobileBreakpoint) {
    const rect = statsRow.getBoundingClientRect();
    const statsBottom = rect.bottom + window.pageYOffset + bottomPadding;
    const scrollPos = window.pageYOffset + window.innerHeight;
    const track = rect.width - statsContent.offsetWidth;

    const perc =
      (scrollPos - statsBottom) / (window.innerHeight / 2 - rect.height);

    const trans = track * perc;
    easedTrans += (trans - easedTrans) * 0.05;

    if (easedTrans > track) {
      easedTrans = track;
    } else if (easedTrans < 0) {
      easedTrans = 0;
    }

    statsRow.style.transform = `translate3d(-${easedTrans}px, 0, 0)`;
  } else {
    statsRow.style.transform = "none";
  }

  requestAnimationFrame(statsScrollAnim);
}

//PLANS ACCORDIONS
function plansAccordions() {
  const accordions = document.querySelectorAll(".accordion-section");
  function sizeAllAccordions() {
    accordions.forEach((accordion) => {
      const accordionHead = accordion.querySelector(".accordion-head");
      const accordionBody = accordion.querySelector(".accordion-body");
      if (!accordionHead) {
        return;
      }

      if (accordion.classList.contains("open")) {
        accordion.style.height = `${
          accordionHead.offsetHeight +
          (accordionBody?.offsetHeight || 0)
        }px`;
      } else {
        accordion.style.height = `${accordionHead.offsetHeight}px`;
      }
    });
  }
  accordions.forEach((accordion) => {
    const accordionHead = accordion.querySelector(".accordion-head");
    if (!accordionHead) {
      return;
    }

    accordionHead.setAttribute("tabindex", "0");

    accordionHead.addEventListener("click", function () {
      accordion.classList.toggle("open");
      if (accordion.classList.contains("open")) {
        spotlightTrackAccordionOpen(
          "feature",
          spotlightCleanDataLayerText(accordionHead)
        );
      }
      sizeAllAccordions();
    });

    accordionHead.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault(); 
        accordion.classList.toggle("open");
        if (accordion.classList.contains("open")) {
          spotlightTrackAccordionOpen(
            "feature",
            spotlightCleanDataLayerText(accordionHead)
          );
        }
        sizeAllAccordions();
      }
    });
  });

  window.addEventListener("resize", sizeAllAccordions);
  sizeAllAccordions();
}

//FAQ ACCORDIONS
function faqAccordions() {
  const accordions = document.querySelectorAll("#faq .accordion .row");
  function sizeAllAccordions() {
    accordions.forEach((accordion) => {
      const rowHeader = accordion.querySelector(".row-header");
      const rowBody = accordion.querySelector(".row-body");
      if (!rowHeader) {
        return;
      }

      if (accordion.classList.contains("open")) {
        accordion.style.height = `${
          rowHeader.offsetHeight +
          (rowBody?.offsetHeight || 0)
        }px`;
      } else {
        accordion.style.height = `${rowHeader.offsetHeight}px`;
      }
    });
  }
  accordions.forEach((accordion) => {
    const rowHeader = accordion.querySelector(".row-header");
    if (!rowHeader) {
      return;
    }

    rowHeader.addEventListener("click", function () {
      accordion.classList.toggle("open");
      if (accordion.classList.contains("open")) {
        spotlightTrackAccordionOpen(
          "faq",
          spotlightCleanDataLayerText(rowHeader)
        );
      }
      sizeAllAccordions();
    });
  });
  window.addEventListener("resize", sizeAllAccordions);
  sizeAllAccordions();
}

//INSURANCE ACCORDIONS
function insuranceAccordions() {
  const accordions = document.querySelectorAll("#insurance .accordion .row");
  function sizeAllAccordions() {
    accordions.forEach((accordion) => {
      const rowHeader = accordion.querySelector(".row-header");
      const rowBody = accordion.querySelector(".row-body");
      if (!rowHeader) {
        return;
      }

      if (accordion.classList.contains("open")) {
        accordion.style.height = `${
          rowHeader.offsetHeight +
          (rowBody?.offsetHeight || 0)
        }px`;
      } else {
        accordion.style.height = `${rowHeader.offsetHeight}px`;
      }
    });
  }
  accordions.forEach((accordion) => {
    const rowHeader = accordion.querySelector(".row-header");
    if (!rowHeader) {
      return;
    }

    rowHeader.addEventListener("click", function () {
      accordion.classList.toggle("open");
      if (accordion.classList.contains("open")) {
        spotlightTrackAccordionOpen(
          "feature",
          spotlightCleanDataLayerText(rowHeader)
        );
      }
      sizeAllAccordions();
    });
  });
  window.addEventListener("resize", sizeAllAccordions);
  sizeAllAccordions();
}

function detailsAccordionsTracking() {
  document.querySelectorAll(".faq__item").forEach((detail) => {
    if (detail.dataset.spotlightAccordionTracked === "true") {
      return;
    }

    detail.dataset.spotlightAccordionTracked = "true";

    detail.addEventListener("toggle", function () {
      if (!detail.open) {
        return;
      }

      spotlightTrackAccordionOpen(
        "faq",
        spotlightCleanDataLayerText(detail.querySelector(".faq__question-text, summary"))
      );
    });
  });
}

//ALL BLOCK IMAGES PARALLAX
const imageBlocks = [];

document
  .querySelectorAll("#home-resources .card .image-wrapper-outer")
  .forEach((block) => {
    imageBlocks.push(block);
  });
document
  .querySelectorAll("#apply-steps .grid-item .image-wrapper-outer")
  .forEach((block) => {
    imageBlocks.push(block);
  });

let easedWinMidY = 0 + window.innerHeight / 2;
const prlxEase = 0.35;

function blocksParallax() {
  const winY = window.pageYOffset;
  const winMidY = winY + window.innerHeight / 2;
  easedWinMidY += (winMidY - easedWinMidY) * prlxEase;

  imageBlocks.forEach((block) => {
    const image = block.querySelector(".image-wrapper-inner");
    if (!image) {
      return;
    }

    const rect = block.getBoundingClientRect();
    const centerPoint = winY + rect.top + rect.height / 2;
    const diff = centerPoint - easedWinMidY;
    image.style.transform = `translate3d(0, ${-diff * 0.1}px, 0)`;
  });

  window.requestAnimationFrame(blocksParallax);
}

//TESTIMONIAL SLIDER BEHAVIOR

const moveSlider = (xPos) => `translate3d(${xPos}px, 0, 0)`;

const getListChildById = (list, index) =>
  [...list.children].find((child) => parseInt(child.dataset.id) === index);

function moveElementBefore(listElement, currentIndex, indexBeingMoved) {
  const currentChild = getListChildById(listElement, currentIndex);
  const movedChild = getListChildById(listElement, indexBeingMoved);
  if (!currentChild || !movedChild) {
    return;
  }

  listElement.insertBefore(
    movedChild,
    currentChild
  );
}

function moveElementAfter(listElement, currentIndex, indexBeingMoved) {
  const movedChild = getListChildById(listElement, indexBeingMoved);
  if (!movedChild) {
    return;
  }

  const listIndexOfCurrentElement = [...listElement.children].findIndex(
    (child) => parseInt(child.dataset.id) === currentIndex
  );
  if (listIndexOfCurrentElement === -1) {
    return;
  }

  listElement.insertBefore(
    movedChild,
    [...listElement.children][listIndexOfCurrentElement + 1]
  );
}

function setUpCarousel(sectionId, isTestimonials, externalIndicatorsId) {
  const prevArrow = document.querySelector(`${sectionId} .arrow.prev`);
  const nextArrow = document.querySelector(`${sectionId} .arrow.next`);
  if (prevArrow) prevArrow.setAttribute("tabindex", "0");
  if (nextArrow) nextArrow.setAttribute("tabindex", "0");
  let indicators = document.querySelector(`${sectionId} .indicators`);
  const externalIndicators = externalIndicatorsId
    ? document.querySelector(externalIndicatorsId)
    : null;
  const slideFrame = document.querySelector(
    `${sectionId} ${isTestimonials ? ".slides-inner" : ".slides"}`
  );
  if (!slideFrame || !slideFrame.children.length || !prevArrow || !nextArrow) {
    return;
  }

  const slideCount = slideFrame.children.length;
  let currentIndex = 0;
  let slideWidth;
  const transformSpeedInMs = 500;
  const shouldTrackTestimonialNav = sectionId === "#testimonials";

  function updateIndicators(newIndex) {
    if (!indicators || !indicators[newIndex]) {
      return;
    }

    [...indicators].forEach((indicator) =>
      indicator.classList.remove("active")
    );
    indicators[newIndex].classList.add("active");
  }

  function updateExternalIndicators(newIndex) {
    if (!externalIndicators?.children[newIndex]) {
      return;
    }

    [...externalIndicators.children].forEach((indicator) => {
      indicator.querySelector(".selected-line")?.classList.remove("active");
    });
    externalIndicators.children[newIndex]
      .querySelector(".selected-line")
      ?.classList.add("active");
  }

  function goToSlide(newIndex, isPrev) {
    if (newIndex < 0 || newIndex >= slideCount) {
      return;
    }

    const oldIndex = currentIndex;
    currentIndex = newIndex;

    if (oldIndex === newIndex) {
      return;
    }

    if (!slideWidth) {
      slideWidth = slideFrame.offsetWidth;
    }

    const moveElement = isPrev ? moveElementBefore : moveElementAfter;
    if (!getListChildById(slideFrame, oldIndex) || !getListChildById(slideFrame, newIndex)) {
      return;
    }

    moveElement(slideFrame, oldIndex, newIndex);
    if (isPrev) {
      slideFrame.style.transform = moveSlider(-1 * slideWidth);
    }
    updateIndicators(newIndex);
    updateExternalIndicators(newIndex);

    setTimeout(function () {
      slideFrame.style.transition = `transform ${
        transformSpeedInMs / 1000
      }s ease`;
      slideFrame.style.transform = moveSlider(isPrev ? 0 : -1 * slideWidth);
    }, 10);

    setTimeout(function () {
      slideFrame.style.transition = "none";
      if (!isPrev) {
        slideFrame.style.transform = moveSlider(0);
        moveElementBefore(slideFrame, oldIndex, newIndex);
      }
    }, transformSpeedInMs);
  }

  function handleIndicatorClick() {
    const clickedIndex = [...this.parentElement.children].findIndex(
      (indicator) => indicator === this
    );
    const activeIndex = [...this.parentElement.children].findIndex(
      (indicator) => [...indicator.classList].includes("active")
    );
    goToSlide(clickedIndex, clickedIndex < activeIndex);
  }

  function handleExternalIndicatorClick() {
    const clickedIndex = [...this.parentElement.children].findIndex(
      (indicator) => indicator === this
    );
    const activeIndex = [...this.parentElement.children].findIndex(
      (indicator) =>
        [...(indicator.querySelector(".selected-line")?.classList || [])].includes(
          "active"
        )
    );
    goToSlide(clickedIndex, clickedIndex < activeIndex);
  }

  // add IDs to each slide
  [...slideFrame.children].forEach((slide, index) => {
    slide.dataset.id = index;
  });

  // generate indicator dots
  if (indicators) {
    indicators.innerHTML = [...Array(slideCount).keys()]
      .map((_) => `<div class="gallery-indicator"></div>`)
      .join("");
    indicators = indicators.getElementsByClassName("gallery-indicator");
    indicators[0]?.classList.add("active");
    [...indicators].forEach((indicator) => {
      indicator.addEventListener("click", handleIndicatorClick);
    });
  }

  // configure click listeners for external indicators
  if (externalIndicators) {
    [...externalIndicators.children].forEach((indicator) => {
      indicator.addEventListener("click", handleExternalIndicatorClick);

      indicator.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleExternalIndicatorClick.call(this);
        }
      });

      indicator.setAttribute("tabindex", "0");
    });
  }

  prevArrow.addEventListener("click", function () {
    goToSlide(currentIndex === 0 ? slideCount - 1 : currentIndex - 1, true);
    if (shouldTrackTestimonialNav) {
      spotlightTrackTestimonialCarouselNav("prev");
    }
  });

  prevArrow.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      goToSlide(currentIndex === 0 ? slideCount - 1 : currentIndex - 1, true);
      if (shouldTrackTestimonialNav) {
        spotlightTrackTestimonialCarouselNav("prev");
      }
    }
  });

  nextArrow.addEventListener("click", function () {
    goToSlide(currentIndex === slideCount - 1 ? 0 : currentIndex + 1, false);
    if (shouldTrackTestimonialNav) {
      spotlightTrackTestimonialCarouselNav("next");
    }
  });

  nextArrow.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      goToSlide(currentIndex === slideCount - 1 ? 0 : currentIndex + 1, false);
      if (shouldTrackTestimonialNav) {
        spotlightTrackTestimonialCarouselNav("next");
      }
    }
  });

  window.addEventListener("resize", function () {
    if (isMobileBreakpoint) {
      slideFrame.style.transform = "none";
      slideFrame.replaceChildren(
        ...[...slideFrame.children].sort(
          (child1, child2) => child1.dataset.id - child2.dataset.id
        )
      );
      currentIndex = 0;

      updateIndicators(0);
      updateExternalIndicators(0);
    } else {
      slideWidth = slideFrame.children[0]?.offsetWidth || slideFrame.offsetWidth;
    }
  });
}

function computeCollapsedHeight(footerDrawer) {
  const title = footerDrawer.children[0];
  if (!title) {
    return 0;
  }

  const styles = window.getComputedStyle(footerDrawer);
  const titleStyles = window.getComputedStyle(title);

  const padding = parseInt(styles.paddingTop) || 0;
  const border = parseInt(styles.borderTopWidth) || 0;
  const titleHeight = parseInt(titleStyles.height) || 0;

  return padding + border + titleHeight;
}

const footerDrawers = document.querySelectorAll("#footer .link-col");

function toggleFooterDrawer() {
  const currentFooterDrawer = this;
  const { scrollHeight } = currentFooterDrawer;
  const currentHeight = parseInt(currentFooterDrawer.style.height);

  currentFooterDrawer.style.height = `${
    currentHeight === scrollHeight
      ? computeCollapsedHeight(currentFooterDrawer)
      : scrollHeight
  }px`;
}

function initFooterDrawers() {
  footerDrawers.forEach((footerDrawer) => {
    footerDrawer.addEventListener("click", toggleFooterDrawer);
  });

  // drawers start collapsed on mobile
  if (isMobileBreakpoint) {
    footerDrawers.forEach((footerDrawer) => {
      footerDrawer.style.height = `${computeCollapsedHeight(footerDrawer)}px`;
    });
  }
}

window.addEventListener("resize", () => {
  footerDrawers.forEach((footerDrawer) => {
    footerDrawer.style.height = isMobileBreakpoint
      ? `${computeCollapsedHeight(footerDrawer)}px`
      : "auto";
  });
});

// update full-height CSS var based on size of navbar
const navbar = document.querySelector("#navbar");
let navbarHeight;
if (navbar) {
  new ResizeObserver(function () {
    const currentHeight = navbar.offsetHeight;

    if (currentHeight === navbarHeight) {
      return;
    }
    if (!isMobileBreakpoint) {
      document
        .querySelector(":root")
        .style.setProperty(
          "--full-height",
          `calc(100vh - ${navbar.offsetHeight}px)`
        );
    } else {
      document
        .querySelector(":root")
        .style.setProperty(
          "--full-height",
          `calc(100dvh - ${navbar.offsetHeight}px)`
        );
    }

    navbarHeight = currentHeight;
  }).observe(navbar);
}

window.addEventListener("resize", function () {
  isMobileBreakpoint = window.innerWidth <= 800;
});

const urlParams = new URLSearchParams(window.location.search);
const categoryOnLoad = urlParams.has("category")
  ? urlParams.get("category")
  : "All";
let tagOnLoad = urlParams.has("tag") ? urlParams.get("tag") : "Popular Tags";
const searchValOnLoad = urlParams.get("search");
let articlesDropdownVal = "All";
let articlesDropdownSlug = "all";
let tagsDropdownVal = "Popular Tags";

function articlesDropdown() {
  const dropdown = document.querySelector("#grid-header #categories-dropdown");
  if (!dropdown) {
    return;
  }

  const sizer = dropdown.querySelector(".sizer");
  const selected = dropdown.querySelector(".selected");
  const list = dropdown.querySelector(".list");
  if (!sizer || !selected || !list) {
    return;
  }

  let options = [["All", "all"]];

  document.querySelectorAll(".categories-source-list div").forEach((category) => {
    options.push([
      category.innerText.trim(),
      category.getAttribute("data-slug"),
    ]);
  });

  function resetOptions() {
    selected.innerHTML = "";
    list.innerHTML = "";

    const selectedOption = options[0][0];
    const selectedSlug = options[0][1];
    const remainingOptions = options.slice(1);

    const selectedOptionDiv = document.createElement("div");
    selectedOptionDiv.classList.add("option");
    selectedOptionDiv.setAttribute("role", "option");
    selectedOptionDiv.setAttribute("aria-selected", "true");
    selectedOptionDiv.setAttribute("tabindex", "0");
    selectedOptionDiv.innerHTML = selectedOption;
    selected.append(selectedOptionDiv);

    remainingOptions.forEach((option) => {
      const optionDiv = document.createElement("div");
      optionDiv.classList.add("option");
      optionDiv.setAttribute("role", "option");
      optionDiv.setAttribute("tabindex", "-1");
      optionDiv.setAttribute("aria-selected", "false");
      optionDiv.setAttribute("data-slug", option[1]);
      optionDiv.innerHTML = option[0];

      const dotDiv = document.createElement("div");
      dotDiv.classList.add("dot");
      dotDiv.style.backgroundColor = `var(--category-${option[1]})`;
      optionDiv.append(dotDiv);

      list.append(optionDiv);
    });
  }

  let longestOption = "";
  options.forEach((option) => {
    if (option[0].length > longestOption.length) {
      longestOption = option[0];
    }
  });
  sizer.innerHTML = longestOption;

  const selectedIndex = Math.max(
    0,
    options.findIndex(option => option[1] === categoryOnLoad)
  );
  articlesDropdownVal = options[selectedIndex][0];
  articlesDropdownSlug = options[selectedIndex][1];
  if (searchInput && searchValOnLoad) {
    searchInput.value = searchValOnLoad;
  }

  options = [
    options[selectedIndex],
    ...[
      ...options.slice(0, selectedIndex),
      ...options.slice(selectedIndex + 1),
    ].sort(),
  ];

  resetOptions();

  document.addEventListener("click", function (event) {
    const target = event.target;
    const isOption = target?.classList?.contains("option");
    if (target === dropdown || dropdown.contains(target)) {
      if (isOption) {
        const selectedVal = target.innerText;
        const selectedIndex = options.findIndex(opt => opt[0] === selectedVal);
        if (selectedIndex === -1) {
          return;
        }

        articlesDropdownVal = selectedVal;
        articlesDropdownSlug = options[selectedIndex][1];

        options = [
          options[selectedIndex],
          ...[
            ...options.slice(0, selectedIndex),
            ...options.slice(selectedIndex + 1),
          ].sort(),
        ];
        resetOptions();
        dropdown.classList.remove("open");
        dropdown.setAttribute("aria-expanded", "false");
      } else {
        dropdown.classList.toggle("open");
        dropdown.setAttribute("aria-expanded", dropdown.classList.contains("open"));
      }
    } else {
      dropdown.classList.remove("open");
      dropdown.setAttribute("aria-expanded", "false");
    }
  });

  // Keyboard support
  dropdown.addEventListener("keydown", function (event) {
  const isOpen = dropdown.classList.contains("open");
  const optionsList = [...list.querySelectorAll(".option")];
  const focusedIndex = optionsList.findIndex(opt => opt === document.activeElement);

  switch (event.key) {
    case "Enter":
    case " ":
      event.preventDefault();
      if (!isOpen) {
        dropdown.classList.add("open");
        dropdown.setAttribute("aria-expanded", "true");
        optionsList[0]?.focus();
      } else if (focusedIndex !== -1) {
        optionsList[focusedIndex].click();
      }
      break;

    case "Escape":
      event.preventDefault();
      dropdown.classList.remove("open");
      dropdown.setAttribute("aria-expanded", "false");
      dropdown.querySelector(".selected .option")?.focus();
      break;

    case "Tab":
      if (!isOpen) return;
      event.preventDefault();
      if (event.shiftKey) {
        const prevIndex = (focusedIndex - 1 + optionsList.length) % optionsList.length;
        optionsList[prevIndex]?.focus();
      } else {
        const nextIndex = (focusedIndex + 1) % optionsList.length;
        optionsList[nextIndex]?.focus();
      }
      break;
  }
});

}

function tagsDropdown() {
  const dropdown = document.querySelector("#grid-header #tags-dropdown");
  if (!dropdown) {
    return;
  }

  const sizer = dropdown.querySelector(".sizer");
  const selected = dropdown.querySelector(".selected");
  const list = dropdown.querySelector(".list");
  if (!sizer || !selected || !list) {
    return;
  }

  let options = [["Popular Tags", "popular-tags"]];

  document.querySelectorAll(".tags-source-list div").forEach((tag) => {
    options.push([tag.innerText.trim(), tag.getAttribute("data-slug")]);
  });

  function resetOptions() {
    selected.innerHTML = "";
    list.innerHTML = "";

    const selectedOption = options[0][0];

    const remainingOptions = options.slice(1);

    const selectedOptionDiv = document.createElement("div");
    selectedOptionDiv.classList.add("t-option");
    selectedOptionDiv.innerHTML = selectedOption;
    selected.append(selectedOptionDiv);

    remainingOptions.forEach((option) => {
      const optionDiv = document.createElement("div");
      optionDiv.classList.add("t-option");
      optionDiv.innerHTML = option[0];
      optionDiv.setAttribute("data-slug", option[1]);

      list.append(optionDiv);
    });
  }

  let longestOption = "";
  options.forEach((option, index) => {
    if (option[0].length > longestOption.length) {
      longestOption = option[0];
    }
  });
  sizer.innerHTML = longestOption;

  let hasTag = false;
  options.forEach((option) => {
    if (option[0] === tagOnLoad) {
      hasTag = true;
    }
  });
  if (hasTag) {
    tagsDropdownVal = tagOnLoad;
  } else {
    tagOnLoad = "Popular Tags";
    tagsDropdownVal = "Popular Tags";
  }

  const selectedIndex = options.findIndex((option) => option[0] === tagOnLoad);

  options = [
    options[selectedIndex],
    ...[
      ...options.slice(0, selectedIndex),
      ...options.slice(selectedIndex + 1),
    ].sort(),
  ];

  resetOptions();

  document.addEventListener("click", function (event) {
    const target = event.target;
    if (target === dropdown || target === selected) {
      dropdown.classList.toggle("open");
    } else if (target?.classList?.contains("t-option")) {
      const selectedVal = [
        target.innerText,
        target.getAttribute("slug"),
      ];
      const selectedIndex = options.findIndex(
        (option) => option[0] === selectedVal[0]
      );
      if (selectedIndex === -1) {
        return;
      }

      tagsDropdownVal = target.innerText;
      options = [
        options[selectedIndex],
        ...[
          ...options.slice(0, selectedIndex),
          ...options.slice(selectedIndex + 1),
        ].sort(),
      ];
      resetOptions();
      dropdown.classList.remove("open");
    } else {
      dropdown.classList.remove("open");
    }
  });
}

function articlesGrid() {
  const articleGrid = document.querySelector("#grid .cards-grid");
  const gridBottom = document.querySelector("#grid .bottom");
  const seeMore = document.querySelector("#grid .see-more-link");
  let currentPage = 1;

  if (!articleGrid || !gridBottom || !seeMore) {
    return;
  }

  const action = {
    "/news-and-advice/": "load_more_news_advice_articles",
    "/help-and-faqs/": "load_more_help_faq_articles",
    "/the-small-print/": "load_more_small_print_articles",
  }[window.location.pathname];
  const queryParams = new URLSearchParams(window.location.search);

  if (!action || !spotlightHasAjax()) {
    return;
  }

  function addMoreArticles() {
    currentPage += 1;

    const oldArticlesCount = articleGrid.children.length;

    spotlightAjax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "json",
      data: {
        action,
        paged: currentPage,
        category: queryParams.get("category"),
        tag: queryParams.get("tag"),
        tagSlug: (queryParams.get("tag") || "").split(" ").join("-"),
        search: queryParams.get("search"),
      },
      success: function (res) {
        if (currentPage >= res.max) {
          gridBottom.style.display = "none";
        }
        articleGrid.innerHTML += res.html;

        setTimeout(() => {
          const newArticles = Array.from(articleGrid.children).slice(oldArticlesCount);
          if (newArticles.length > 0) {
            if (!newArticles[0].hasAttribute('tabindex')) {
              newArticles[0].setAttribute('tabindex', '-1');
            }
            newArticles[0].focus();
          }
        }, 0);
      },
    });
  }

  seeMore.addEventListener("click", addMoreArticles);
}

const newsAdviceSearchForm = document.getElementById("search-form");
const searchInput = document.querySelector("#search-form .search-input input");
if (newsAdviceSearchForm && searchInput) {
  newsAdviceSearchForm.addEventListener("submit", function (event) {
    event.preventDefault();
    if (articlesDropdownVal !== "All") {
      urlParams.set("category", articlesDropdownSlug);
    } else {
      urlParams.delete("category");
    }

    if (tagsDropdownVal !== "Popular Tags") {
      urlParams.set("tag", tagsDropdownVal);
    } else {
      urlParams.delete("tag");
    }

    if (searchInput.value !== "") {
      urlParams.set("search", searchInput.value);
    } else {
      urlParams.delete("search");
    }

    if (spotlightIsNewsAdvicePage()) {
      spotlightPushDataLayer({
        event: "article_search",
        searchTerm: searchInput.value.trim(),
        articleCategory: articlesDropdownVal !== "All" ? articlesDropdownVal : "",
        articleTags: tagsDropdownVal !== "Popular Tags" ? tagsDropdownVal : "",
      });
    }

    window.location.search = urlParams.toString();
  });
}

/////

function desktopNavSubMenus() {
  if (!isMobileBreakpoint) {
    const links = navbar?.querySelector(".links");
    if (!links) {
      window.requestAnimationFrame(desktopNavSubMenus);
      return;
    }

    const linksRect = links.getBoundingClientRect();
    navbar.querySelectorAll(".submenu").forEach((submenu) => {
      submenu.style.paddingLeft = `${linksRect.left}px`;
      submenu.style.paddingRight = `${window.innerWidth - linksRect.right}px`;
    });
  }

  window.requestAnimationFrame(desktopNavSubMenus);
}

document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.nav-link.menu');
  let currentOpenMenu = null;
  const navbar = document.querySelector('#navbar');

  if (!navbar || !menuItems.length) {
    return;
  }

  const toggleSubmenu = (menuItem, open) => {
    if (!menuItem) {
      menuItems.forEach(item => {
        item.classList.remove('open');
        item.querySelector('button')?.setAttribute('aria-expanded', 'false');
        item.querySelectorAll('.submenu a').forEach(link =>
          link.setAttribute('tabindex', '-1')
        );
      });
      currentOpenMenu = null;
      return;
    }

    const isOpen = open ?? !menuItem.classList.contains('open');

    menuItems.forEach(item => {
      const isCurrent = item === menuItem && isOpen;
      item.classList.toggle('open', isCurrent);
      
      const btn = item.querySelector('button');
      if (btn) btn.setAttribute('aria-expanded', isCurrent);

      item.querySelectorAll('.submenu a').forEach(link => 
        link.setAttribute('tabindex', isCurrent ? '0' : '-1')
      );
    });

    currentOpenMenu = isOpen ? menuItem : null;
    if (isOpen && menuItem.querySelector('.submenu a')) {
      setTimeout(() => menuItem.querySelector('.submenu a').focus(), 10);
    }
  };

  const closeAllSubmenus = () => toggleSubmenu(null, false);

  menuItems.forEach(menuItem => {
    const submenuLinks = menuItem.querySelectorAll('.submenu a');
    submenuLinks.forEach(link => link.setAttribute('tabindex', '-1'));

    const button = menuItem.querySelector('button');
    if (button) {
      button.addEventListener('click', () => toggleSubmenu(menuItem));
      button.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          closeAllSubmenus();
          button.focus();
        }
      });
    }

    submenuLinks.forEach((link, index) => {
      link.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeAllSubmenus();
          button?.focus();
        } else if (e.key === 'Tab' && !e.shiftKey && index === submenuLinks.length - 1) {
          setTimeout(closeAllSubmenus, 10);
        }
      });
    });
  });

  document.addEventListener('click', e => {
    if (!navbar.contains(e.target)) closeAllSubmenus();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Tab' && currentOpenMenu && !navbar.contains(document.activeElement)) {
      closeAllSubmenus();
    }
  });
});

function mobileMenu() {
  const hamburger = document.querySelector(".mobile-menu-button");
  if (!hamburger || !navbar) {
    return;
  }

  hamburger.addEventListener("click", function () {
    navbar.classList.toggle("open");
    document.body.classList.toggle("frozen");
  });

  const menuLinks = navbar.querySelectorAll(".nav-link.menu");

  menuLinks.forEach((menuLink) => {
    menuLink.addEventListener("click", function () {
      if (window.innerWidth <= 1240) {
        menuLinks.forEach((otherLink) => {
          if (otherLink === menuLink) {
            otherLink.classList.toggle("open");
          } else {
            otherLink.classList.remove("open");
          }
        });
      }
    });
  });

  window.addEventListener("resize", function () {
    navbar.classList.remove("open");
    if (!document.getElementById("login-modal")?.classList.contains("open")) {
      document.body.classList.remove("frozen");
    }
    menuLinks.forEach((menuLink) => {
      menuLink.classList.remove("open");
    });
  });
}

function setupMobileDropdowns() {
  const dropdowns = document.querySelectorAll(".dropdown");

  dropdowns.forEach((dropdown) => {
    const toggle = dropdown.querySelector(".dropdown-toggle-header");
    const menu = dropdown.querySelector(".dropdown-menu");

    if (toggle && menu) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = toggle.getAttribute("aria-expanded") === "true";

        dropdowns.forEach((otherDropdown) => {
          if (otherDropdown !== dropdown) {
            const otherToggle = otherDropdown.querySelector(
              ".dropdown-toggle-header"
            );
            const otherMenu = otherDropdown.querySelector(".dropdown-menu");
            if (otherToggle && otherMenu) {
              otherToggle.setAttribute("aria-expanded", "false");
              otherMenu.classList.remove("show");
            }
          }
        });

        if (isOpen) {
          toggle.setAttribute("aria-expanded", "false");
          menu.classList.remove("show");
        } else {
          toggle.setAttribute("aria-expanded", "true");
          menu.classList.add("show");
        }
      });
    }
  });
}

async function getNames(term) {
  const validationMessage = document.getElementById("name-search-validation");

  try {
    const response = await fetch(
      `https://monickerapi.spotlight.com/monicker/search/casting?term=${encodeURIComponent(
        term
      )}`
    );

    if (!response.ok) {
      throw new Error("Name checker request failed");
    }

    const namesList = await response.json();
    const isTaken = Array.isArray(namesList) && namesList.length > 0;

    if (isTaken) {
      validationMessage.innerHTML = "Name is already taken.";
      validationMessage.style.display = "block";
      validationMessage.style.color = "#d3053b";
    } else {
      validationMessage.innerHTML =
        "It looks like this name is available from an initial check on the system. Our team will need to do further checks to confirm this.";
      validationMessage.style.display = "block";
      validationMessage.style.color = "black";
    }

    spotlightPushDataLayer({
      event: "name_checker_result",
      result: isTaken ? "taken" : "available",
    });
  } catch (error) {
    validationMessage.innerHTML =
      "Sorry, we could not check that name right now. Please try again.";
    validationMessage.style.display = "block";
    validationMessage.style.color = "#d3053b";

    spotlightPushDataLayer({
      event: "name_checker_result",
      result: "error",
    });
  }
}

const nameSearchForm = document.getElementById("name-search-form");

if (nameSearchForm) {
  nameSearchForm.addEventListener("submit", function (event) {
    event.preventDefault();
    if (nameSearchForm.querySelector("input").value === "") {
      document.getElementById("name-search-validation").innerHTML =
        "This field is required.";
      document.getElementById("name-search-validation").style.display = "block";
      document.getElementById("name-search-validation").style.color = "#d3053b";
    } else {
      document.getElementById("name-search-validation").style.display = "none";
      spotlightPushDataLayer({
        event: "name_checker_submit",
      });
      getNames(nameSearchForm.querySelector("input").value);
    }
  });
}

const spotlightStudioFormNamesById = {
  4874: "studio_booking",
  5472: "voiceover_booking",
};

function spotlightGetForminatorFormId(form) {
  const formIdInput = form.querySelector('input[name="form_id"]');

  return formIdInput?.value || form.getAttribute("data-form-id") || "";
}

function spotlightGetStudioFormName(form) {
  const formId = spotlightGetForminatorFormId(form);

  if (spotlightStudioFormNamesById[formId]) {
    return spotlightStudioFormNamesById[formId];
  }

  if (
    form.closest(".section-voiceover-booth-hire") ||
    window.location.pathname.includes("voiceover")
  ) {
    return "voiceover_booking";
  }

  if (form.closest("#request-space, .section-studio-space-hire")) {
    return "studio_booking";
  }

  return "";
}

function spotlightGetSubmittedControlValues(control, formData) {
  if (!formData || !control.name) {
    return [];
  }

  return formData.getAll(control.name).map((value) => String(value));
}

function spotlightGetChoiceLabel(control) {
  const label = control.closest("label");

  return spotlightCleanDataLayerText(label) || control.value;
}

function spotlightGetFieldSubmittedValues(field, formData) {
  const values = [];

  field.querySelectorAll("select").forEach((select) => {
    const submittedValues = spotlightGetSubmittedControlValues(select, formData);
    const matchingOptions = Array.from(select.options).filter((option) =>
      submittedValues.length
        ? submittedValues.includes(option.value)
        : option.selected
    );

    matchingOptions.forEach((option) => {
      if (option.value !== "") {
        values.push(spotlightCleanDataLayerText(option) || option.value);
      }
    });
  });

  field
    .querySelectorAll('input[type="checkbox"], input[type="radio"]')
    .forEach((input) => {
      const submittedValues = spotlightGetSubmittedControlValues(input, formData);
      const wasSubmitted = submittedValues.length
        ? submittedValues.includes(input.value)
        : input.checked;

      if (wasSubmitted) {
        values.push(spotlightGetChoiceLabel(input));
      }
    });

  return values.filter(Boolean);
}

function spotlightGetStudioSelection(form, formData, formName) {
  const fieldKeywords = /studio|space|room|booth|hire|booking/i;
  const values = [];

  form.querySelectorAll(".forminator-field").forEach((field) => {
    if (!fieldKeywords.test(spotlightCleanDataLayerText(field))) {
      return;
    }

    values.push(...spotlightGetFieldSubmittedValues(field, formData));
  });

  const uniqueValues = [...new Set(values.map((value) => value.trim()))].filter(
    Boolean
  );

  if (uniqueValues.length) {
    return uniqueValues.join(", ");
  }

  return formName === "voiceover_booking" ? "Voiceover Booth" : "";
}

function spotlightGetFormErrorField(error) {
  const element = error?.element;

  if (!element) {
    return "";
  }

  return (
    element.getAttribute("name") ||
    element.getAttribute("data-field") ||
    element.id ||
    ""
  ).replace(/\[\]$/, "");
}

function spotlightGetForminatorErrors(errorArgs) {
  return errorArgs.reduce((errors, errorArg) => {
    if (!errorArg) {
      return errors;
    }

    if (Array.isArray(errorArg)) {
      errors.push(...errorArg);
      return errors;
    }

    errors.push(errorArg);
    return errors;
  }, []);
}

function setupForminatorDataLayerTracking() {
  if (!window.jQuery) {
    return;
  }

  const $ = window.jQuery;
  const validationAttempts = new WeakMap();

  $(document).on("forminator:form:submit:success", ".forminator-custom-form", function (
    event,
    formData
  ) {
    const formName = spotlightGetStudioFormName(this);

    if (!formName) {
      return;
    }

    spotlightPushDataLayer({
      event: "form_submit",
      formName,
      studioSelection: spotlightGetStudioSelection(this, formData, formName),
    });
  });

  $(document).on("validation:invalid", ".forminator-custom-form", function () {
    validationAttempts.set(this, true);
  });

  $(document).on("validation:showError", ".forminator-custom-form", function (event) {
    const formName = spotlightGetStudioFormName(this);

    if (!formName || !validationAttempts.get(this)) {
      return;
    }

    validationAttempts.set(this, false);

    spotlightGetForminatorErrors(
      Array.prototype.slice.call(arguments, 1)
    ).forEach((error) => {
      spotlightPushDataLayer({
        event: "form_validation_error",
        formName,
        errorField: spotlightGetFormErrorField(error),
        errorMessage: error?.message || String(error || ""),
      });
    });
  });
}

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

if (document.querySelector("#footer")) {
  /*
  const footerSubButton = document.createElement("button");
  const footerSubButtonImg = document.createElement("img");
  footerSubButton.setAttribute("type", "submit");
  footerSubButtonImg.setAttribute(
    "src",
    "https://stg-spotlight-stage.kinsta.cloud/wp-content/uploads/2023/10/submit-arrow.png"
  );
  footerSubButton.append(footerSubButtonImg);
  const formField = document.querySelector(
    "#footer .forminator-ui.forminator-custom-form[data-design='default'] .forminator-field"
  );
  if (formField) {
    formField.append(footerSubButton);
  }
  */

  /*
  if (document.querySelector("#request-space form")) {
    document
      .querySelector("#request-space form .forminator-button-submit")
      .classList.add("button", "solid", "body-copy-1");
    document
      .querySelector("#request-space form .forminator-button-submit")
      .classList.remove("forminator-button", "forminator-button-submit");
    document
      .querySelector("#request-space form button")
      .setAttribute("type", "submit");
  }
  */

  waitForElm(".forminator-ui .forminator-button-submit").then((elm) => {
    const forminatorButton = document.querySelector(
      ".forminator-ui .forminator-button-submit"
    );
    if (forminatorButton) {
      forminatorButton.style.borderRadius = "30px";
      forminatorButton.classList.add("button", "solid", "body-copy-1");
    }
  });
}

const getCookieValue = (name) =>
  document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";

const canAccessPremiereContent = async (openPaywallModal) => {
  // const isLoggedInUser = !!getCookieValue("spotlight.user");
  // const isProduction = window.location.host === "spotlight.com";

  /*
    if (!isLoggedInUser) {
      return false;
    }
  
    try {
      const response = await fetch(
        isProduction
          ? `https://profileapi.spotlight.com/marketing/user/`
          : `https://stagingaws-profileapi.spotlabs.uk/marketing/user/`,
        {
          method: "GET",
          headers: {
            "X-Spotlight-Marketing": isProduction
              ? "bd5639ce-5541-44f9-b11f-f321543cd975"
              : "60562278-af93-4eb5-bd41-8c8961677085",
          },
        }
      );
      const jsonResponse = await response.json();
      return (jsonResponse?.entitlements || []).includes("premium_site_access");
    } catch (e) {
      console.error(e);
      return false;
    }
    */

  if (!spotlightHasAjax()) {
    openPaywallModal();
    return;
  }

  spotlightAjax("https://profileapi.spotlight.com/marketing/user/", {
    method: "GET",
    headers: {
      "X-Spotlight-Marketing": "bd5639ce-5541-44f9-b11f-f321543cd975",
    },
    xhrFields: { withCredentials: true },
    crossDomain: true,
    type: "jsonp",
    contentType: "application/json",
    secure: true,
    success: function (res) {
      const isPremiereUser = (res?.entitlements || []).includes(
        "premium_site_access"
      );
      if (!isPremiereUser) {
        openPaywallModal();
      }
    },
    error: function (res) {
      openPaywallModal();
    },
  });
};

function setActiveNavLink() {
  const currentPath = window.location.href;
  const navbar = document.getElementById("navbar");

  if (!navbar) return;

  navbar.querySelectorAll("a[href]").forEach((link) => {
    const linkHref = link.href;

    if (
      currentPath === linkHref ||
      currentPath.startsWith(linkHref)
    ) {
      link.classList.add("current");

      const parentNavItem = link.closest(".nav-item");
      if (parentNavItem) {
        parentNavItem.classList.add("current");
      }
    }
  });
}


function checkIfLoggedIn() {
  if (!spotlightHasAjax()) {
    return;
  }

  function success() {
    const signInButton = document.querySelector("#sign-in-button");
    if (signInButton) {
      signInButton.innerText = "My Home";
      signInButton.setAttribute("href", "https://app.spotlight.com/myhome");
    }
  }

  spotlightAjax("https://profileapi.spotlight.com/marketing/user/", {
    method: "GET",
    headers: {
      "X-Spotlight-Marketing": "bd5639ce-5541-44f9-b11f-f321543cd975",
    },
    xhrFields: { withCredentials: true },
    crossDomain: true,
    type: "jsonp",
    contentType: "application/json",
    secure: true,
    success: function (res) {
      if (res.portalId && res.entitlements) {
        success();
      }
    },
    error: function (res) {},
  });
}

//MODAL FUNCTIONS
const loginModal = document.getElementById("login-modal");
const nav = document.querySelector('.navbar');
const openJoinPage = () => {
  window.location.assign("/join-us/");
};

window.openLoginModal = openJoinPage;

if (loginModal) {
  const focusableSelectors = 'a[href], button, textarea, input, select';
  let lastFocusedElement = null;

  const setModalTabIndices = disabled => {
    loginModal.querySelectorAll(focusableSelectors).forEach(el => 
      disabled ? el.setAttribute("tabindex", "-1") : el.removeAttribute("tabindex")
    );
  };

  window.openLoginModal = () => {
    loginModal.classList.add("open");
    document.body.classList.add("frozen");
    nav?.classList.remove("open");
    loginModal.setAttribute("aria-hidden", "false");
    setModalTabIndices(false);
    lastFocusedElement = document.activeElement;
    loginModal.querySelector(focusableSelectors)?.focus();
  };

  const closeLoginModal = () => {
    loginModal.classList.remove("open");
    document.body.classList.remove("frozen");
    loginModal.setAttribute("aria-hidden", "true");
    setModalTabIndices(true);
    lastFocusedElement?.focus();
  };

  loginModal.querySelector(".modal-close")?.addEventListener("click", closeLoginModal);
  
  loginModal.addEventListener("click", e => e.target === loginModal && closeLoginModal());

  document.addEventListener("keydown", e => {
    if (!loginModal.classList.contains("open")) return;
    
    if (e.key === "Escape") return closeLoginModal();
    
    if (e.key === "Tab") {
      const focusables = [...loginModal.querySelectorAll(focusableSelectors)];
      if (!focusables.length) return e.preventDefault();
      
      const first = focusables[0], last = focusables.slice(-1)[0];
      if ((e.shiftKey && document.activeElement === first) || 
          (!e.shiftKey && document.activeElement === last)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      }
    }
  });

  setModalTabIndices(true);
  loginModal.setAttribute("aria-hidden", "true");
}

//PREMIERE PAYWALL MODAL
const paywall = document.querySelector("#premiere-paywall");
const isPremierePage = document.querySelector(".is-premiere-page");
if (paywall && isPremierePage) {
  const focusableSelectors = 'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
  let lastFocusedElement = null;

  const setPaywallTabIndices = disabled => {
    paywall.querySelectorAll(focusableSelectors).forEach(el => 
      disabled ? el.setAttribute("tabindex", "-1") : el.removeAttribute("tabindex")
    );
  };

  const openPaywallModal = () => {
    paywall.classList.add("open");
    document.body.classList.add("frozen");
    paywall.setAttribute("aria-hidden", "false");
    setPaywallTabIndices(false);
    lastFocusedElement = document.activeElement;
  };

  const closePaywallModal = () => {
    paywall.classList.remove("open");
    document.body.classList.remove("frozen");
    paywall.setAttribute("aria-hidden", "true");
    window.location.replace("/");
  };

  paywall.querySelector(".modal-close")?.addEventListener("click", closePaywallModal);
  paywall.querySelector(".button")?.addEventListener("click", closePaywallModal);

  document.addEventListener("keydown", e => {
    if (!paywall.classList.contains("open")) return;
    
    if (e.key === "Escape") return closePaywallModal();
    
    if (e.key === "Tab") {
      const focusables = [...paywall.querySelectorAll(focusableSelectors)];
      if (!focusables.length) return;
      
      const first = focusables[0], last = focusables.slice(-1)[0];
      if ((e.shiftKey && document.activeElement === first) || 
          (!e.shiftKey && document.activeElement === last)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      }
    }
  });

  canAccessPremiereContent(openPaywallModal);
  setPaywallTabIndices(true);
  paywall.setAttribute("aria-hidden", "true");
}

//NEW HOMEPAGE JUMBOTRON CAROUSEL

function setUpHomePageCarousel() {
  const carousel = document.getElementById("home-page-carousel");
  const dotsWrapper = carousel.querySelector(".indicator-dots");
  const playToggle = carousel.querySelector(".play-toggle");
  const progressBar = carousel.querySelector(".bar");
  const imagesD = carousel.querySelectorAll(".desktop-images img");
  const imagesM = carousel.querySelectorAll(".mobile-images img");
  if (!dotsWrapper || !playToggle || !progressBar || !imagesD.length || !imagesM.length) {
    return;
  }

  const trans = `transform 1s ease`;
  const noTrans = `transform 0s linear`;
  let canChangeImage = true;

  const secsPerImage = 5;
  let playing = true;
  let timerProgress = 0;

  function updateProgress() {
    if (playing) {
      timerProgress += 10;
      progressBar.style.transform = `scaleX(${
        timerProgress / (secsPerImage * 1000)
      })`;
      if (timerProgress > secsPerImage * 1000) {
        nextImage();
      }
    }
  }

  let currentIndex = 0;
  let prevIndex = 0;
  const finalIndex = imagesD.length - 1;

  imagesD.forEach((image, index) => {
    const dot = document.createElement("div");
    dot.classList.add("dot");
    if (index === currentIndex) {
      dot.classList.add("current");
    }

    dot.addEventListener("click", function () {
      if (canChangeImage) {
        canChangeImage = false;
        prevIndex = currentIndex;
        currentIndex = index;
        positionImages();
      }
    });
    dotsWrapper.append(dot);
  });

  function updateDots() {
    dotsWrapper.querySelectorAll(".dot").forEach((dot, index) => {
      if (index === currentIndex) {
        dot.classList.add("current");
      } else {
        dot.classList.remove("current");
      }
    });
  }

  function positionImages() {
    timerProgress = 0;
    progressBar.style.transform = `scaleX(${
      timerProgress / (secsPerImage * 1000)
    })`;
    imagesD.forEach((image, index) => {
      if (index === prevIndex || index === currentIndex) {
        image.style.transition = trans;
      } else {
        image.style.transition = noTrans;
      }

      if (index === currentIndex) {
        image.style.transform = "none";
      } else if (index > currentIndex) {
        if (index === finalIndex && currentIndex === 0) {
          image.style.transform = "translate3d(-100%, 0, 0)";
        } else {
          image.style.transform = "translate3d(100%, 0, 0)";
        }
      } else if (index < currentIndex) {
        if (index === 0 && currentIndex === finalIndex) {
          image.style.transform = "translate3d(100%, 0, 0)";
        } else {
          image.style.transform = "translate3d(-100%, 0, 0)";
        }
      }
    });
    imagesM.forEach((image, index) => {
      if (index === prevIndex || index === currentIndex) {
        image.style.transition = trans;
      } else {
        image.style.transition = noTrans;
      }

      if (index === currentIndex) {
        image.style.transform = "none";
      } else if (index > currentIndex) {
        if (index === finalIndex && currentIndex === 0) {
          image.style.transform = "translate3d(-100%, 0, 0)";
        } else {
          image.style.transform = "translate3d(100%, 0, 0)";
        }
      } else if (index < currentIndex) {
        if (index === 0 && currentIndex === finalIndex) {
          image.style.transform = "translate3d(100%, 0, 0)";
        } else {
          image.style.transform = "translate3d(-100%, 0, 0)";
        }
      }
    });
    updateDots();

    setTimeout(function () {
      canChangeImage = true;
    }, 1100);
  }

  function nextImage() {
    if (canChangeImage) {
      canChangeImage = false;
      prevIndex = currentIndex;
      if (currentIndex + 1 <= finalIndex) {
        currentIndex += 1;
      } else {
        currentIndex = 0;
      }
      positionImages();
    }
  }

  function prevImage() {
    if (canChangeImage) {
      canChangeImage = false;
      prevIndex = currentIndex;
      if (currentIndex > 0) {
        currentIndex -= 1;
      } else {
        currentIndex = finalIndex;
      }
      positionImages();
    }
  }

  playToggle.addEventListener("click", function () {
    playing = !playing;
    this.classList.toggle("paused");
  });

  playToggle.addEventListener("keydown", function (e) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    playing = !playing;
    this.classList.toggle("paused");
  }
});

  // document.addEventListener("keyup", function (event) {
  //   if (event.key === "ArrowLeft") {
  //     prevImage();
  //   } else if (event.key === "ArrowRight") {
  //     nextImage();
  //   }
  // });

  positionImages();
  setInterval(updateProgress, 10);
}

////

//RUN ALL FUNCTIONS

setupForminatorDataLayerTracking();

scrollTriggerAnims();

startStopVideos();

blocksParallax();

if (document.querySelector("#statistics")) {
  statsScrollAnim();
}

if (document.querySelector("#testimonials")) {
  setUpCarousel("#testimonials", true);
}

if (document.querySelector("#rooms-studios-gallery")) {
  setUpCarousel("#rooms-studios-gallery");
}

if (document.querySelector("#rooms-gallery")) {
  setUpCarousel("#rooms-gallery");
}

if (document.querySelector("#spaces")) {
  setUpCarousel("#spaces .component-image-carousel", false, "#spaces .options");
}

initFooterDrawers();

if (document.querySelector("#plans .accordion")) {
  plansAccordions();
}

if (document.querySelector("#faq .accordion")) {
  faqAccordions();
}

if (document.querySelector("#insurance .accordion")) {
  insuranceAccordions();
}

detailsAccordionsTracking();

if (document.querySelector("#grid-header #categories-dropdown")) {
  articlesDropdown();
}

if (document.querySelector("#grid-header #tags-dropdown")) {
  tagsDropdown();
}

if (document.querySelector("#navbar")) {
  desktopNavSubMenus();
  mobileMenu();
}

if (navbar) {
  setActiveNavLink();
  checkIfLoggedIn();
}

if (document.querySelector("#grid")) {
  articlesGrid();
}

//NEW HOME PAGE CAROUSEL
if (document.getElementById("home-page-carousel")) {
  setUpHomePageCarousel();
}
